import React from 'react';
import styles from './MessageArea.module.css';

const MessageArea = ({ messages, playerPosition }) => {
  const positionClass =
    playerPosition === 'bottom-left' ? styles.message_area_bottom_left : styles.message_area_top_right;

  return (
    <div className={`${styles.message_area} ${positionClass}`}>
      {messages.map((message) => (
        <div key={message.id} className={`${styles.message} ${styles[message.type]}`}>
          {message.text}
        </div>
      ))}
    </div>
  );
};

export default MessageArea;